export default {"src":"/_next/static/media/tutor_control_schedule.6e8d12a6.svg","height":756,"width":955};